/**
 * Counting Number Animation
 * Animates numbers from 0 to target value when scrolled into view
 * Supports decimals, commas, prefixes, and suffixes
 */

document.addEventListener('DOMContentLoaded', function() {
  const countingNumbers = document.querySelectorAll('.counting-number');
  
  if (!countingNumbers.length) return;

  // Intersection Observer options
  const observerOptions = {
    threshold: 0.5, // Trigger when 50% of element is visible
    rootMargin: '0px'
  };

  // Format number with commas or decimals
  function formatNumber(num, originalTarget) {
    // Remove commas from original target to check for actual decimals
    const cleanTarget = originalTarget.replace(/,/g, '');
    const hasComma = originalTarget.includes(',');
    const hasDecimal = cleanTarget.includes('.');
    
    if (hasDecimal) {
      // Determine decimal places from target
      const decimalPlaces = cleanTarget.split('.')[1]?.length || 1;
      return num.toFixed(decimalPlaces);
    } else if (hasComma) {
      // Add thousand separators
      return Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    
    return Math.round(num).toString();
  }

  // Animate counting
  function animateCount(element, target, duration = 2000) {
    const startTime = performance.now();
    const startValue = 0;
    
    // Parse target (remove commas for calculation)
    const targetValue = parseFloat(target.replace(/,/g, ''));
    
    function updateCount(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const currentValue = startValue + (targetValue - startValue) * easeOut;
      
      element.textContent = formatNumber(currentValue, target);
      
      if (progress < 1) {
        requestAnimationFrame(updateCount);
      } else {
        // Ensure final value matches exactly
        element.textContent = formatNumber(targetValue, target);
      }
    }
    
    requestAnimationFrame(updateCount);
  }

  // Create intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.dataset.animated) {
        const targetValue = entry.target.dataset.target;
        
        // Mark as animated to prevent re-triggering
        entry.target.dataset.animated = 'true';
        
        // Start animation
        animateCount(entry.target, targetValue);
      }
    });
  }, observerOptions);

  // Observe all counting numbers
  countingNumbers.forEach(number => {
    observer.observe(number);
  });
});
